import { useSurveysPageContext } from 'pages/surveys/context/surveysPageContext'
import { SurveyView } from 'pages/surveys/ui/SurveyView/SurveyView'

export const CreateSurvey = () => {
  const { pageLayoutStore } = useSurveysPageContext()

  return <SurveyView pageLayoutStore={pageLayoutStore} />
}
